/* The signed-in user — the `user` object of `GET /settings`, verbatim
   (tasks/auth-pages/CONTRACT.md). Snake_case is the wire shape and stays the
   wire shape: a camelCase mirror would only be a second place to be wrong.

   There is no module-level instance any more. The user is server state, so it
   lives in TanStack Query behind `shared/api/settings` and nowhere else. */

/** A resolved LPC character: every field is a wardrobe or palette id.
    `shared/avatar`'s `resolveAvatar` produces it and the Settings customizer
    writes it back whole — it is never a partial override. */
export interface AvatarLook {
  head: string;
  hair: string;
  hairColor: string;
  skin: string;
  top: string;
  topColor: string;
  bottom: string;
  bottomColor: string;
  shoes: string;
  shoesColor: string;
}

export interface User {
  id: string;
  email: string;
  /** null until onboarding asks for it. */
  first_name: string | null;
  last_name: string | null;
  /** An IANA zone name, or null while it is unset. */
  timezone: string | null;
}

/** What to call someone: both names, either name, else the email's local part.
    Never empty — every user has an email. */
export const displayName = (u: User): string =>
  [u.first_name, u.last_name].filter(Boolean).join(" ").trim() || u.email.split("@")[0];
